// Core
import { createActions } from 'redux-actions';

export const geoActions = createActions({
    GET_SUGGESTS:          (text = '') => text,
    GET_SUGGESTS_SUCCESS:  (locations) => locations,
    GET_SUGGESTS_FAIL:     (error) => error,
    GET_COUNTRIES:         () => void 0,
    GET_COUNTRIES_SUCCESS: (countries) => countries,
    GET_COUNTRIES_FAIL:    (error) => error,
    EMPTY_CITIES:          () => void 0,
    GET_CITIES:            (countryId) => countryId,
    GET_CITIES_SUCCESS:    (countryId, cities) => ({ countryId, cities }),
    GET_CITIES_FAIL:       (error) => error,
    EMPTY_HOTELS:          () => void 0,
    GET_HOTELS:            (countryId, cities, categories, services) => ({ countryId, cities, categories, services }),
    GET_HOTELS_SUCCESS:    (countryId, hotels) => ({ countryId, hotels }),
    GET_HOTELS_FAIL:       (error) => error,
});
